
// Vectary Scripts v2.4.0 - November 11, 2025
// Added C7 color support and L1/L2 logo color sliders
console.log('Vectary Scripts loading...');
import { VctrModelApi } from "https://www.vectary.com/studio-lite/scripts/api.js";
console.log('Vectary Scripts loaded, checking for ColorGridPopup availability:', typeof window.ColorGridPopup);
let selectedOverlaminateMaterial = "MAT-GLOSS"

// Color palette organized by color groups from the CSV file
const colorPalette = [
  // Blacks & Grays
  "#000000", "#1a1e25", "#2e2c26", "#323232", "#434244", "#4e4b48", 
  "#716e6a", "#75726e", "#6a6c70", "#777677", "#75787b", "#797c81", 
  "#88898c", "#898d96", "#b1b3b3", "#bbbab9", "#c8cacc", "#d9d9d6", "#ffffff",
  
  // Pinks & Reds
  "#ed008c", "#e10098", "#ce0076", "#c2214d", "#772935", "#8e2631", 
  "#c61f15", "#cc2229", "#de2d32", "#da0002", "#ff0000", "#f9423a",
  
  // Oranges
  "#d63205", "#dc4410", "#d75d18", "#d6692e", "#d8752d", "#ff6d00", "#ff9d00", 
  "#fead77", "#ffc166",
  
  // Yellows
  "#e4a612", "#ffc41d", "#f5d230", "#c7c84d", "#f5d130", "#fdee00", "#fcf73a", 
  "#dbe442", "#dae343", "#dee829", "#ddf84a", "#ddfc4a", "#c0df16", "#b8f63b",
  "#cecf3b",
  
  // Greens
  "#5bc500", "#00b176", "#5b6236", "#00b878", "#545941",
  
  // Blues & Teals
  "#a5b0e3", "#a0d1ca", "#a0d1ca", "#5ebdd4", "#00c7d1", "#2db1bd", "#3790b0", 
  "#00778b", "#004f59", "#17a4cc", "#00acec", "#0091da", "#008bce", "#0082ba", 
  "#007dba", "#0074c5", "#93a1aa", "#597a9b", "#006298", "#005297", "#043bff", 
  "#0c15a9", "#003594", "#2d396b", "#183165", "#162667", "#2a385d", "#223A5E",
  "#26385e", "#697b8b", "#7a8ed3",
  
  // Tans & Browns
  "#7d725b", "#a49764", "#b4875e", "#b2945e", "#b5a588", "#a39d88", "#b3ae9b",
  "#bbb39e",
  
  // Purples
  "#291844", "#69488e", "#440099"
];
  // *** Define sliderConfigs here, before it's needed ***
  const sliderConfigs = [
    {
      sliderId: "swatchSliderC7",
      displayId: "colorDisplayC7",
      nameId: "colorNameC7",
      lockId: "lockC7",
      objects: ["wrapkit-partial 7", "wrapkit-full 7"],
      material: "MAT-GLOSS-C7",
    },
    {
      sliderId: "swatchSliderC6",
      displayId: "colorDisplayC6",
      nameId: "colorNameC6",
      lockId: "lockC6",
      objects: ["wrapkit-partial 6", "wrapkit-full 6"],
      material: "MAT-GLOSS-C6",
    },
    // Model color (MC1) is now controlled only via presets
    {
      sliderId: "swatchSliderC5",
      displayId: "colorDisplayC5",
      nameId: "colorNameC5",
      lockId: "lockC5",
      objects: [
        "color-less-5",
        "wrapkit-partial 5",
        "wrapkit-full 5",
        "wrapkit-premium 5",
      ],
      material: "MAT-GLOSS-C5",
    },
    {
      sliderId: "swatchSliderC4",
      displayId: "colorDisplayC4",
      nameId: "colorNameC4",
      lockId: "lockC4",
      objects: ["wrapkit-partial 4", "wrapkit-full 4"],
      material: "MAT-GLOSS-C4",
    },
    {
      sliderId: "swatchSliderC3",
      displayId: "colorDisplayC3",
      nameId: "colorNameC3",
      lockId: "lockC3",
      objects: ["wrapkit-partial 3", "wrapkit-full 3"],
      material: "MAT-GLOSS-C3",
    },
    {
      sliderId: "swatchSliderC2",
      displayId: "colorDisplayC2",
      nameId: "colorNameC2",
      lockId: "lockC2",
      objects: ["wrapkit-partial 2", "wrapkit-full 2"],
      material: "MAT-GLOSS-C2",
    },
    {
      sliderId: "swatchSliderC1",
      displayId: "colorDisplayC1",
      nameId: "colorNameC1",
      lockId: "lockC1",
      objects: ["wrapkit-partial 1", "wrapkit-full 1"],
      material: "MAT-GLOSS-C1",
    },
    {
      sliderId: "swatchSliderBG",
      displayId: "colorDisplayBG",
      nameId: "colorNameBG",
      lockId: "lockBG",
      objects: ["background_object"],
      material: "MAT-GLOSS-BG",
    },
    {
      sliderId: "swatchSliderL1",
      displayId: "colorDisplayL1",
      nameId: "colorNameL1",
      lockId: "lockL1",
      objects: ["wrapkit-partial 1", "wrapkit-full 1"],
      material: "MAT-Logos-L1", 
    },
    {
      sliderId: "swatchSliderL2",
      displayId: "colorDisplayL2",
      nameId: "colorNameL2",
      lockId: "lockL2",
      objects: ["wrapkit-partial 2", "wrapkit-full 2"],
      material: "MAT-Logos-L2", 
    },
    // Model color controls for Advanced Settings
    {
      sliderId: "swatchSliderMC1",
      displayId: "colorDisplayMC1",
      nameId: "colorNameMC1",
      lockId: "lockMC1",
      objects: ["model-object", "model-detail"],
      material: "Model-MAT-C1",
    },
    {
      sliderId: "swatchSliderMC2",
      displayId: "colorDisplayMC2",
      nameId: "colorNameMC2",
      lockId: "lockMC2",
      objects: ["model-object", "model-detail"],
      material: "Model-MAT-C2",
    },
    {
      sliderId: "swatchSliderMC3",
      displayId: "colorDisplayMC3",
      nameId: "colorNameMC3",
      lockId: "lockMC3",
      objects: ["model-object", "model-detail"],
      material: "Model-MAT-C3",
    },
    {
      sliderId: "swatchSliderMC4",
      displayId: "colorDisplayMC4",
      nameId: "colorNameMC4",
      lockId: "lockMC4",
      objects: ["model-object", "model-detail"],
      material: "Model-MAT-C4",
    },
  ];
// Helper function to get color properties from the UI
function getColorProperties() {
  // Try to get color values from the DOM
  try {
    // Find all color displays to extract current colors
    const colorProperties = {};

    // Direct selectors for color swatches
    const colorDisplays = {
      C7: document.getElementById("colorDisplayC7"),
      C6: document.getElementById("colorDisplayC6"),
      C5: document.getElementById("colorDisplayC5"),
      C4: document.getElementById("colorDisplayC4"),
      C3: document.getElementById("colorDisplayC3"),
      C2: document.getElementById("colorDisplayC2"),
      C1: document.getElementById("colorDisplayC1"),
      BG: document.getElementById("colorDisplayBG"),
      L1: document.getElementById("colorDisplayL1"),
      L2: document.getElementById("colorDisplayL2"),
      MC1: document.getElementById("colorDisplayMC1"),
      MC2: document.getElementById("colorDisplayMC2"),
      MC3: document.getElementById("colorDisplayMC3"),
      MC4: document.getElementById("colorDisplayMC4"),
    };

    const colorNames = {
      C7: document.getElementById("colorNameC7"),
      C6: document.getElementById("colorNameC6"),
      C5: document.getElementById("colorNameC5"),
      C4: document.getElementById("colorNameC4"),
      C3: document.getElementById("colorNameC3"),
      C2: document.getElementById("colorNameC2"),
      C1: document.getElementById("colorNameC1"),
      BG: document.getElementById("colorNameBG"),
      L1: document.getElementById("colorNameL1"),
      L2: document.getElementById("colorNameL2"),
      MC1: document.getElementById("colorNameMC1"),
      MC2: document.getElementById("colorNameMC2"),
      MC3: document.getElementById("colorNameMC3"),
      MC4: document.getElementById("colorNameMC4"),
    };

    Object.keys(colorDisplays).forEach((key) => {
      const display = colorDisplays[key];
      const nameElement = colorNames[key];

      if (display && nameElement) {
        const bgColor = window.getComputedStyle(display).backgroundColor;
        const colorName = nameElement.textContent;

        // Convert rgb to hex if needed
        function rgbToHex(rgb) {
          if (rgb.startsWith("#")) return rgb;

          // Parse RGB values
          const rgbMatch = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
          if (rgbMatch) {
            const r = parseInt(rgbMatch[1], 10).toString(16).padStart(2, "0");
            const g = parseInt(rgbMatch[2], 10).toString(16).padStart(2, "0");
            const b = parseInt(rgbMatch[3], 10).toString(16).padStart(2, "0");
            return `#${r}${g}${b}`;
          }
          return rgb;
        }

        const hexColor = rgbToHex(bgColor);

        // Format the key and value in a standardized way
        const propertyKey = `Color_${key.replace(/[^a-zA-Z0-9]/g, "")}`;
        const propertyValue = `${colorName} (${hexColor})`;

        // Add to properties object
        colorProperties[propertyKey] = propertyValue;
      }
    });

  // Also add dropdown selections to properties
  const modelEngine = document.getElementById('model-engine')?.value;
  const modelPackage = document.getElementById('model-package')?.value;
  const modelYear = document.getElementById('model-year')?.value;
  const modelTrim = document.getElementById('model-trim')?.value;
  if (modelEngine) colorProperties['Engine'] = modelEngine;
  if (modelPackage) colorProperties['Package'] = modelPackage;
  if (modelYear) colorProperties['Model Year'] = modelYear;
  if (modelTrim) colorProperties['Trim Level'] = modelTrim;
  
  // Add logo information to properties
  if (window.state && window.state.activeLogos && window.state.activeLogos.size > 0) {
    const logos = Array.from(window.state.activeLogos.values());
    logos.forEach((logoData, index) => {
      const logoNum = index + 1;
      colorProperties[`Logo ${logoNum}`] = logoData.title || logoData.handle || 'Custom Logo';
      if (logoData.text) {
        colorProperties[`Logo ${logoNum} Description`] = logoData.text;
      }
    });
  }
  
  return colorProperties;
  } catch (error) {
    console.error("Error getting color properties:", error);
    return {};
  }
}
// --- Color Swatches Data ---
const color_swatches_data = {};
const rawColorData = [
  // Blacks & Grays
  "Black#000000",
  "True Black#000000", 
  "Timeless Black#2e2c26",
  "Can-Am Dark Grey#323232",
  "Charcoal Grey#434244",
  "Eclipise Grey#4e4b48",
  "Steel Grey#6a6c70",
  "Sport Grey#716e6a",
  "Platinum Silver#75726e",
  "Coastal Grey#75787b",
  "Defender Grey#777677",
  "Can-Am Maverick Grey#797c81",
  "Liquid Titanium#7d725b",
  "Catalyst Dark Grey#88898c",
  "Monument Grey#898d96",
  "LYNX Titanium#a39d88",
  "LYNX Titanium2#b3ae9b",
  "Desert Tan#b5a588",
  "Can-Am Silver#bbbab9",
  "Catalyst Grey#c8cacc",
  "Gris Silex#b1b3b3",
  "Hybrid White#d9d9d6",
  "White#ffffff",
  
  // Greens
  "Army Green#5b6236",
  "Racing Green#004631",
  "Quetzal Green#00b176",
  "Laguna Green#00b878",
  "Vintage Arctic Cat Green#5bc500",
  "Vintage Manta Green#c0df16",
  "Arctic Cat Green#b8f63b",
  "Manta Green#ddf84a",
  "Neo Mint#99cccc",
  "Wilderness Green#545941",
  
  // Reds & Pinks
  "Chile Peper Red#772935",
  "Spartan Red#8e2631",
  "R.B. Pink#c2214d",
  "Lava Dark Red#c61f15",
  "Sea-Doo Magenta#ce0076",
  "Honda Red / LYNX Red#cc2229",
  "M.O.T Red#de2d32",
  "True Red / Polaris Red#da0002",
  "Rhodamine#e10098",
  "D.S Pink#ed008c",
  "Red Orange#ff0000",
  "Coral Blast#f9423a",
  
  // Oranges
  "Orange Phoenix2#d6692e",
  "Sunrise Orange#ffc166",
  "Arctic Cat Orange / KTM / Polaris Burst#d75d18",
  "Orange Phoenix#d8752d",
  "Unlimited Lava / Can-Am Red / Trixx Red#d63205",
  "Blaze Orange#dc4410",
  "Ski-Doo Dark Orange#ff6d00",
  "Orange Crush#ff9d00",
  
  // Yellows
  "Flare Yellow#cecf3b",
  "Can-Am Yellow#e4a612",
  "Vintage Ski-Doo Yellow#f5d130",
  "RB-Yellow#f5d230",
  "Millennium Yellow#ffc41d",
  "Ski-doo#fdee00",
  "Sunburst Yellow - Ski-doo / Sea-Doo / Can-Am#fcf73a",
  "Neo Yellow#dbe442",
  "Polaris Lime Squeeze#dae343",
  "Nuclear Yellow#dee829",
  "Dayglow#ddfc4a",
  
  // Golds & Tans
  "Ski-Doo Gold#a49764",
  "Can-Am Gold#b2945e",
  "Polaris Glow#b4875e",
  "Metallic Tan#bbb39e",
  "Sand#bbb39e",
  
  // Blues
  "SCS Wraps Blue#0074c5",
  "SCS Blue Black#1a1e25",
  "Mineral Blue#223A5E",
  "Vintage Polaris Blue#162667",
  "Labrador Blue#183165",
  "Dusty Navy#1b365d",
  "Ski-Doo Dark Blue#2a385d",
  "R.B Motorsports Blue#2d396b",
  "Panama Turquoise#004f59",
  "Oxford Blue#005297",
  "Sea-Doo Belize Blue#006298",
  "Iceberg Blue#00778b",
  "Gulfstream Blue#007dba",
  "Carribean Blue#0082ba",
  "Can-Am Sea-Doo Blue#008bce",
  "Octane Blue#0091da",
  "Teal M#0091b3",
  "Cyan#00acec",
  "LYNX Cyan#17a4cc",
  "Reef Blue#2db1bd",
  "Turquoise#00c7d1",
  "Scandi Blue#567a9b",
  "Yahmaha Blue#0b0dae",
  "Dazzling Blue#043bff",
  "Vapor Blue#a5b0e3",
  "Vapor Dark Blue#7a8ed3",
  "Abyss Blue#26385e",
  "Airy Blue#697b8b",
  "Light Blue#aee6ff",
  
  // Purples
  "Midnight Purple#291844",
  "Violet#440099",
  "Arctic Cat Purple#69488e"
].join("");

function parseColorData(rawData) {
  const colorsArray = [];
  const pairs = rawData.match(/[^#]+#[0-9a-fA-F]{6}/g) || [];
  pairs.forEach((pair) => {
    const parts = pair.split("#");
    if (parts.length >= 2) {
      const hex = `#${parts.pop()}`;
      const name = parts.join("#");
      if (hex.match(/^#[0-9a-fA-F]{6}$/)) {
        colorsArray.push({ name: name.trim(), hex: hex });
      } else {
        console.warn(`Skipping invalid entry: ${pair}`);
      }
    } else {
      console.warn(`Skipping malformed entry: ${pair}`);
    }
  });
  if (colorsArray.length === 0) {
    console.error("Failed to parse color data, using default fallback.");
    return [{ name: "Default White", hex: "#ffffff" }];
  }
  return colorsArray;
}

const structuredColors = parseColorData(rawColorData);
const numColors = structuredColors.length;

// Expose structured colors globally for the color grid popup
window.structuredColors = structuredColors;

for (let i = 1; i <= 100; i++) {
  const colorIndex = (i - 1) % numColors;
  color_swatches_data[`A${i}`] = structuredColors[colorIndex].name; // Assign name to 'A' key
  color_swatches_data[`B${i}`] = structuredColors[colorIndex].hex; // Assign hex to 'B' key
}

// Product data (Not used for logic anymore, but kept for reference/prices)
const products = [
  { level: 1, name: "Ski-Doo Gen5 Level 1", price: "$349.95", url: "#" },
  { level: 2, name: "Ski-Doo Gen5 Level 2", price: "$75.00", url: "#" },
  { level: 3, name: "Ski-Doo Gen5 Level 3", price: "$75.00", url: "#" },
  { level: 4, name: "Ski-Doo Gen5 Level 4", price: "$75.00", url: "#" },
];

const selectedColor = document.querySelector(
  '[data-handle="color"] [data-variant-input]:checked'
);
const selectedColorValue = selectedColor ? selectedColor.value : null;
const selectedColorIndex = selectedColor
  ? Array.from(
      document.querySelectorAll('[data-handle="color"] [data-variant-input]')
    ).indexOf(selectedColor)
  : 0;

// Utility: normalize material ids and state color values (top-level for global access)
function normalizeMaterialId(input) {
  if (!input) return '';
  let s = String(input).trim();
  if (s.includes('-')) {
    const parts = s.split('-').filter(Boolean);
    if (parts.length) {
      s = parts[parts.length - 1];
    }
  }
  s = s.replace(/^[^A-Za-z0-9]+/, '');
  return s;
}

function normalizeStateColorValues() {
  try {
    if (!window.state || !window.state.colorValues) return;
    const normalized = {};
    Object.keys(window.state.colorValues).forEach((k) => {
      const nk = normalizeMaterialId(k);
      if (nk) normalized[nk] = window.state.colorValues[k];
    });
    window.state.colorValues = normalized;
  } catch (_) {
    // no-op
  }
}

// Functions to save and load color values from localStorage
function saveColorValuesToStorage() {
  try {
  // Normalize keys before saving
  normalizeStateColorValues();
    // Save color values
    localStorage.setItem('vectaryColorValues', JSON.stringify(state.colorValues));
    
    // Save active preset if any
    if (state.activePreset) {
      localStorage.setItem('vectaryActivePreset', state.activePreset);
    } else {
      localStorage.removeItem('vectaryActivePreset');
    }
    
    // Save selected overlaminate material
    localStorage.setItem('vectaryOverlaminateMaterial', selectedOverlaminateMaterial);
    
    // Save active overlaminates
    localStorage.setItem('vectaryActiveOverlaminates', JSON.stringify(Array.from(state.activeOverlaminates)));
    
    console.log('Saved color values to localStorage:', state.colorValues);
  } catch (error) {
    console.error('Error saving color values to localStorage:', error);
  }
}

function loadColorValuesFromStorage() {
  try {
    // Load color values
    const savedColorValues = localStorage.getItem('vectaryColorValues');
    if (savedColorValues) {
      state.colorValues = JSON.parse(savedColorValues);
      console.log('Loaded color values from localStorage:', state.colorValues);
    }
    
    // Load active preset
    const savedActivePreset = localStorage.getItem('vectaryActivePreset');
    if (savedActivePreset) {
      state.activePreset = parseInt(savedActivePreset, 10);
      console.log('Loaded active preset from localStorage:', state.activePreset);
    }
    
    // Load selected overlaminate material
    const savedOverlaminateMaterial = localStorage.getItem('vectaryOverlaminateMaterial');
    if (savedOverlaminateMaterial) {
      selectedOverlaminateMaterial = savedOverlaminateMaterial;
      console.log('Loaded overlaminate material from localStorage:', selectedOverlaminateMaterial);
    }
    
    // Load active overlaminates
    const savedActiveOverlaminates = localStorage.getItem('vectaryActiveOverlaminates');
    if (savedActiveOverlaminates) {
      const overlaminates = JSON.parse(savedActiveOverlaminates);
      state.activeOverlaminates = new Set(overlaminates);
      console.log('Loaded active overlaminates from localStorage:', Array.from(state.activeOverlaminates));
    }
    
    return true;
  } catch (error) {
    console.error('Error loading color values from localStorage:', error);
    return false;
  }
}

// State management
const state = {
  // *** REMOVED selectedLevels ***
  activePreset: selectedColorIndex + 1 || 1,
  lockedMaterials: {
    C5: false,
    C4: false,
    C3: false,
    C2: false,
    C1: false,
    BG: false,
    L1: false, // Added for Logos
    L2: false, // Added for Logos
    MC1: false, // Model Body
    MC2: false, // Model Skis
    MC3: false, // Model Trim
    MC4: false, // Model Seat
    // Model colors (MC1, MC2, etc.) will be added dynamically based on preset data
  },
  colorValues: {
    C5: 1,
    C4: 20,
    C3: 40,
    C2: 60,
    C1: 80,
    BG: 12,
    L1: 20, // Default value for Logos
    L2: 36, // Default value for Logos (red)
    MC1: 28, // Model Body - White (#FFFFFF)
    MC2: 1, // Model Skis - Black (#000000)
    MC3: 34, // Model Trim - Red (#d63205)
    MC4: 34, // Model Seat - Red (#d63205)
    // Model color values will be added dynamically based on preset data
  },
  activeLevels: new Set(), // Add a Set to track active levels
  activeOverlaminates: new Set(), // Add a Set to track active overlaminates
  activeLogos: new Map(), // Add a Map to track active logos with their text descriptions
};

// Make state accessible to other scripts
window.state = state;

// Make function available globally for other event handlers
window.addMultipleProductsToCart = function (
  productIds,
  colorProperties
) {
  console.log("Adding multiple products to cart:", productIds);
  console.log("With properties:", colorProperties);

  // Prepare items array for cart update
  const items = productIds.map(p => ({
    id: parseInt(p.id),
    quantity: 1,
    properties: {}
  }));
  
  // Add main product with color properties (including logos) if it exists
  if (window.mainProduct) {
    items.push({
      id: parseInt(window.mainProduct.id),
      quantity: 1,
      properties: colorProperties
    });
  }

  let formData = {
    'items': items
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(data => {
    console.log("All products added to cart", data);
    window.location.href = "/cart";
  })
  .catch((error) => {
    console.error("Error adding products to cart:", error);
    alert(
      "There was an error adding the products to your cart. Please try again."
    );
  });
};

// Also make addToCartWithColorProperties globally available
window.addToCartWithColorProperties = function (
  variant_id,
  quantity,
  colorProperties
) {
  // Prepare the line item data
  const data = {
    id: variant_id,
    quantity: quantity,
    properties: colorProperties,
  };

  // Add to cart using the Cart API
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((item) => {
      console.log("Product added to cart with color properties:", item);
      // Redirect to checkout
      window.location.href = "/checkout";
    })
    .catch((error) => {
      console.error("Error adding product to cart:", error);
      alert(
        "There was an error adding this product to the cart. Please try again."
      );
    });
};

// --- Main Application Logic ---
// Wrap in DOMContentLoaded to ensure iframe exists
document.addEventListener("DOMContentLoaded", () => {
  // *** Declare API instance variable in this scope ***
  let modelApi = null;
  let isApiReady = false;
  
  // Load saved color values from localStorage
  const valuesLoaded = loadColorValuesFromStorage();
  const statusMessage = document.getElementById("status-message");

  // Load presets from metafields embedded on preset buttons
  const presets = (function loadPresetsFromDOM() {
    const map = {};
    try {
      const buttons = document.querySelectorAll('.preset-button');
      console.log('🔍 DEBUG: Found preset buttons:', buttons.length);
      
      buttons.forEach((btn, idx) => {
        const id = btn.id || '';
        const m = id.match(/color-(\d+)-btn/);
        const number = m ? parseInt(m[1], 10) : (idx + 1);
        const raw = btn.getAttribute('data-colors');
        
        console.log(`🔍 DEBUG: Button ${number} raw data:`, raw);
        
        if (!raw) return;
        let arr;
        try { arr = JSON.parse(raw); } catch (_) { return; }
        
        console.log(`🔍 DEBUG: Button ${number} parsed colors:`, arr);
        
        const obj = {};
        arr.forEach((entry) => {
          if (!entry) return;
          const key = entry.color_key || entry.key || entry.name;
          if (!key) return;
          
          console.log(`🔍 DEBUG: Processing entry with key "${key}":`, entry);
          
          // Check if this is a model color
          const isModelColor = key.startsWith('MC') || key.startsWith('Model-');
          console.log(`🔍 DEBUG: Key "${key}" is model color:`, isModelColor);
          
          // Prefer hex if provided; fall back to numeric index if it's there
          const hex = entry.background_color || entry.color_hex || entry.hex || entry.hex_value || entry.value_hex;
          const idxVal = entry.color_index || entry.index || entry.swatch || entry.value_index;
          let val = null;
          if (typeof hex === 'string' && /^#?[0-9a-fA-F]{6}$/.test(hex)) {
            val = hex.startsWith('#') ? hex : `#${hex}`;
          } else if (typeof idxVal === 'number') {
            val = idxVal;
          } else if (typeof idxVal === 'string' && /^\d+$/.test(idxVal)) {
            val = parseInt(idxVal, 10);
          }
          if (val !== null) {
            // For model colors, store both the color value and the material name
            if (isModelColor && entry.material) {
              obj[key] = {
                color: val,
                material: entry.material
              };
              console.log(`🔍 DEBUG: Added model color "${key}": ${val} with material "${entry.material}" to preset ${number}`);
            } else {
              obj[key] = val;
              console.log(`🔍 DEBUG: Added "${key}": "${val}" to preset ${number}`);
            }
          }
        });
        if (Object.keys(obj).length) {
          map[number] = obj;
          console.log(`🔍 DEBUG: Final preset ${number}:`, obj);
        }
      });
    } catch (e) {
      console.error('🔍 DEBUG: Error loading presets:', e);
    }
    console.log('🔍 DEBUG: All loaded presets:', map);
    return map;
  })();



  // --- Define ALL functions first ---
  const hexToRgb = (hex) => {
    const cleanHex = hex.startsWith("#") ? hex.slice(1) : hex;
    if (cleanHex.length !== 6) {
      console.warn(`Invalid hex color: ${hex}. Using white.`);
      return [255, 255, 255];
    }
    const r = parseInt(cleanHex.substring(0, 2), 16);
    const g = parseInt(cleanHex.substring(2, 4), 16);
    const b = parseInt(cleanHex.substring(4, 6), 16);
    return [r, g, b];
  };

  // Normalize various material identifiers (e.g., 'MAT-GLOSS-C5', 'GLOSS-C5', '-C5') to canonical keys like 'C5'
  function normalizeMaterialId(input) {
    if (!input) return '';
    let s = String(input).trim();
    // If it's a full material path, use the last hyphen-delimited token
    if (s.includes('-')) {
      const parts = s.split('-').filter(Boolean);
      if (parts.length) {
        s = parts[parts.length - 1];
      }
    }
    // Strip any non-alphanumeric prefix (e.g., leading '-')
    s = s.replace(/^[^A-Za-z0-9]+/, '');
    return s;
  }

  function normalizeStateColorValues() {
    try {
      const normalized = {};
      Object.keys(state.colorValues || {}).forEach((k) => {
        const nk = normalizeMaterialId(k);
        if (nk) normalized[nk] = state.colorValues[k];
      });
      state.colorValues = normalized;
    } catch (_) { /* no-op */ }
  }

  function colorDistanceSq(hexA, hexB) {
    const [ar, ag, ab] = hexToRgb(hexA);
    const [br, bg, bb] = hexToRgb(hexB);
    const dr = ar - br;
    const dg = ag - bg;
    const db = ab - bb;
    return dr * dr + dg * dg + db * db;
  }

  function findNearestSwatchIndex(targetHex) {
    let bestIndex = 1;
    let bestDist = Infinity;
    for (let i = 1; i <= (typeof numColors !== 'undefined' ? numColors : 100); i++) {
      const key = `B${i}`;
      const swatchHex = color_swatches_data[key];
      if (!swatchHex) continue;
      const dist = colorDistanceSq(targetHex, swatchHex);
      if (dist < bestDist) {
        bestDist = dist;
        bestIndex = i;
      }
    }
    return bestIndex;
  }

  function getColorNameFromHex(targetHex) {
    if (!targetHex) return 'Unknown Color';
    
    // Clean the hex color
    const cleanHex = targetHex.startsWith('#') ? targetHex : `#${targetHex}`;
    
    // Find the nearest color index
    const nearestIndex = findNearestSwatchIndex(cleanHex);
    
    // Get the color name using the A key (name) for that index
    const colorName = color_swatches_data[`A${nearestIndex}`];
    
    return colorName || 'Unknown Color';
  }

  // Make the functions globally available
  window.getColorNameFromHex = getColorNameFromHex;
  window.findNearestSwatchIndex = findNearestSwatchIndex;

  async function updateMaterialColor(
    api,
    sliderElement,
    displayElement,
    nameElement,
    objectNames,
    materialName,
    hexOverride
  ) {
    if (!sliderElement || !displayElement || !nameElement) {
      console.error(
        `Slider, display, or name element not found for ${materialName}.`
      );
      return;
    }
    if (!isApiReady || !api || typeof api.addOrEditMaterial !== "function") {
      console.warn(
        `API not ready or addOrEditMaterial missing for ${materialName}. Cannot update material color.`
      );
      return;
    }
    if (typeof color_swatches_data === "undefined") {
      console.error("The `color_swatches_data` object is not defined.");
      return;
    }

    // Ensure the underlying Vectary API method is fully ready before use
    try {
      await waitForApiMethod(api, "addOrEditMaterial", 100, 100);
    } catch (_) {
      console.warn("addOrEditMaterial did not become available in time; skipping material update.");
      return;
    }

    const sliderValue = parseInt(sliderElement.value, 10);
    const keyA = `A${sliderValue}`;
    const keyB = `B${sliderValue}`;
    const computedHex = color_swatches_data.hasOwnProperty(keyB)
      ? color_swatches_data[keyB]
      : "#FFFFFF";
    const hexColor = hexOverride || computedHex;
    const colorName = color_swatches_data.hasOwnProperty(keyA)
      ? color_swatches_data[keyA]
      : "Unknown";

    // Update header background color instead of swatch
    const header = displayElement ? displayElement.closest('.accordion-item')?.querySelector('.accordion-header[data-color-header]') : null;
    if (header) {
      header.style.backgroundColor = hexColor;
      // Determine text color based on brightness
      const [r, g, b] = hexToRgb(hexColor);
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      header.style.color = brightness > 128 ? '#000000' : '#ffffff';
      // Update SVG stroke colors
      const svgs = header.querySelectorAll('svg');
      svgs.forEach(svg => {
        svg.style.stroke = brightness > 128 ? '#000000' : '#ffffff';
      });
    }
    
    if (displayElement) {
      displayElement.style.backgroundColor = hexColor;
      displayElement.closest(".color-control").querySelector('.color-slider').style.setProperty('--color-value', hexColor);
    }
    if (nameElement) nameElement.textContent = colorName;
  const materialId = normalizeMaterialId(materialName);
    console.log(11,materialId, state.colorValues);
    state.colorValues[materialId] = sliderValue;
    const [r255, g255, b255] = hexToRgb(hexColor);
    const color = { x: r255, y: g255, z: b255 };

    // Determine material name based on whether it's a Model material or wrap kit material
    let dynamicMaterialName;
    if (materialName.startsWith('Model-MAT-')) {
      // For Model materials, use the exact material name without overlaminate prefix
      dynamicMaterialName = materialName;
    } else {
      // For wrap kit materials, use the original logic with overlaminate selection
      dynamicMaterialName = materialName;
    }
    
    console.log('Using material name:', dynamicMaterialName, 'for objects:', objectNames, 'selectedOverlaminateMaterial:', selectedOverlaminateMaterial);
    console.log('--------------------------------');
    
    if (!Array.isArray(objectNames) || objectNames.length === 0) {
      return;
    }
    for (const objectName of objectNames) {
      try {
        console.log(objectName, dynamicMaterialName, color);
        
        let materialNameForAPI;
        if (materialName.startsWith('Model-MAT-')) {
          // For Model materials, use the exact material name without any prefix
          materialNameForAPI = materialName;
        } else {
          // For wrap kit materials, use the overlaminate prefix
          materialNameForAPI = selectedOverlaminateMaterial + '-' + materialId;
        }
        
        console.log(`Attempting to apply material: ${materialNameForAPI} to object: ${objectName}`);
        
        try {
          const result = api && typeof api.addOrEditMaterial === 'function'
            ? await api.addOrEditMaterial.call(api, objectName, {
                name: materialNameForAPI,
                baseColor: { color },
              })
            : null;
          
          console.log(`✅ Successfully applied ${materialNameForAPI} to ${objectName}`);
        } catch (materialError) {
          console.warn(`❌ Failed to apply material ${materialNameForAPI} to ${objectName}:`, materialError);
          
          // Fallback: Try with MAT-GLOSS prefix if the original fails
          if (selectedOverlaminateMaterial !== 'MAT-GLOSS') {
            try {
              const fallbackMaterialName = 'MAT-GLOSS-' + materialId;
              console.log(`🔄 Trying fallback material: ${fallbackMaterialName} for ${objectName}`);
              
              await api.addOrEditMaterial.call(api, objectName, {
                name: fallbackMaterialName,
                baseColor: { color },
              });
              
              console.log(`✅ Fallback successful: Applied ${fallbackMaterialName} to ${objectName}`);
            } catch (fallbackError) {
              console.warn(`❌ Fallback also failed for ${objectName}:`, fallbackError);
            }
          }
        }
      } catch (_) {
        // Intentionally ignore to avoid breaking UI on missing/hidden objects
      }
    }
    
    // Save the updated color values to localStorage
    saveColorValuesToStorage();
  }

  // Function to update slider background with SVG gradient
  function updateSliderBackground(sliderElement, colors) {
  }

  function initializeSliderUI() {
    sliderConfigs.forEach((config) => {
      const sliderElement = document.getElementById(config.sliderId);
      const displayElement = document.getElementById(config.displayId);
      const nameElement = document.getElementById(config.nameId);
      const lockElement = document.getElementById(config.lockId);
  const materialId = normalizeMaterialId(config.material);

      if (sliderElement && displayElement && nameElement && lockElement) {
        // Apply SVG gradient background to the slider
        updateSliderBackground(sliderElement, colorPalette);
        
        sliderElement.value = state.colorValues[materialId] || 50;
        const updateSliderDisplay = () => {
          const sliderValue = parseInt(sliderElement.value, 10);
          const keyA = `A${sliderValue}`;
          const keyB = `B${sliderValue}`;
          const hexColor = color_swatches_data.hasOwnProperty(keyB)
            ? color_swatches_data[keyB]
            : "#FFFFFF";
          const colorName = color_swatches_data.hasOwnProperty(keyA)
            ? color_swatches_data[keyA]
            : "Unknown";
          displayElement.style.backgroundColor = hexColor;
          nameElement.textContent = colorName;
          state.colorValues[materialId] = sliderValue;
        };
        updateSliderDisplay(); // Initial UI update

        lockElement.addEventListener("click", function () {
          state.lockedMaterials[materialId] =
            !state.lockedMaterials[materialId];
          this.classList.toggle("locked", state.lockedMaterials[materialId]);
        });

        // Add event listener for color grid popup button if it exists
        const colorGridBtn = document.querySelector(`[data-slider="${config.sliderId}"].color-grid-popup-btn`);
        if (colorGridBtn) {
          colorGridBtn.addEventListener("click", function(event) {
            event.preventDefault();
            console.log(`Color grid button clicked for slider: ${config.sliderId}`);
            
            // Robust waiting mechanism for ColorGridPopup
            const openColorGridPopup = async () => {
              let attempts = 0;
              const maxAttempts = 30; // 3 seconds at 100ms intervals
              
              while (typeof window.ColorGridPopup === 'undefined' && attempts < maxAttempts) {
                console.log(`Waiting for ColorGridPopup... attempt ${attempts + 1}/${maxAttempts}`);
                await new Promise(resolve => setTimeout(resolve, 100));
                attempts++;
              }
              
              if (typeof window.ColorGridPopup !== 'undefined') {
                console.log('ColorGridPopup is now available, opening for slider:', config.sliderId);
                try {
                  await window.ColorGridPopup.open(config.sliderId);
                } catch (error) {
                  console.error('Error opening ColorGridPopup:', error);
                }
              } else {
                console.error('ColorGridPopup failed to load after waiting 3 seconds. Please check if color-grid-popup.js is included.');
              }
            };
            
            openColorGridPopup();
          });
          
          console.log(`Color grid popup button set up for slider: ${config.sliderId}`);
        } else {
          console.warn(`Color grid popup button not found for slider: ${config.sliderId}`);
        }
      } else {
        console.warn(`HTML elements not found for slider config:`, config);
      }
    });
  }

  function initializeSlidersWithAPI(api) {
    sliderConfigs.forEach((config) => {
      const sliderElement = document.getElementById(config.sliderId);
      const displayElement = document.getElementById(config.displayId);
      const nameElement = document.getElementById(config.nameId);
      const lockElement = document.getElementById(config.lockId); // Needed for listener
  const materialId = normalizeMaterialId(config.material);

      if (sliderElement && displayElement && nameElement && lockElement) {
        // Add input listener that calls API
        sliderElement.addEventListener("input", function () {
          if (!state.lockedMaterials[materialId]) {
            // Update UI first (already done by initializeSliderUI listener)
            // Then update Vectary material using the same approach as presets
            updateMaterialColor(
              api,
              this,
              displayElement,
              nameElement,
              config.objects,
              config.material
            );
            
            // Dispatch the same event that presets use to restabilize the API
            if (isApiReady && api && typeof api.dispatchEvent === "function") {
              // Find which preset this color value matches and dispatch that event
              const currentValue = parseInt(this.value, 10);
              for (let presetNum = 1; presetNum <= 6; presetNum++) {
                if (presets[presetNum] && presets[presetNum][materialId] === currentValue) {
                  const eventName = `color-${presetNum}-btn`;
                  api.dispatchEvent(eventName);
                  break;
                }
              }
            }
            
            // Re-apply overlaminate configuration to restabilize the API (same as presets do)
            if (
              isApiReady &&
              api &&
              typeof api.setConfigurationState === "function" &&
              state.activeOverlaminates &&
              state.activeOverlaminates.size > 0
            ) {
              try {
                const activeHandle = Array.from(state.activeOverlaminates)[0];
                api.setConfigurationState([
                  { variant: "Variants-Media", active_object: activeHandle },
                ]).catch(e => {
                  console.warn("Failed to re-apply overlaminate after slider change", e);
                });
              } catch (e) {
                console.warn("Failed to re-apply overlaminate after slider change", e);
              }
            }
            
            if (state.activePreset !== null) {
              state.activePreset = null;
              updatePresetButtons();
            }
          }
        });
        // Trigger initial material update
        updateMaterialColor(
          api,
          sliderElement,
          displayElement,
          nameElement,
          config.objects,
          config.material
        );
      }
    });
  }

  function waitForApiMethod(
    apiInstance,
    methodName,
    maxRetries = 50,
    interval = 100
  ) {
    return new Promise((resolve, reject) => {
      let retries = 0;
      const checkInterval = setInterval(() => {
        if (apiInstance && typeof apiInstance[methodName] === "function") {
          clearInterval(checkInterval);
          console.log(`API method '${methodName}' is available.`);
          resolve();
        } else {
          retries++;
          console.log(
            `Waiting for API method '${methodName}'... (Attempt ${retries})`
          );
          if (retries >= maxRetries) {
            clearInterval(checkInterval);
            reject(
              new Error(
                `API method '${methodName}' did not become available after ${
                  maxRetries * interval
                }ms.`
              )
            );
          }
        }
      }, interval);
    });
  }

  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // Safely invoke Vectary's addOrEditMaterial ensuring correct `this` binding
  // and shielding the UI from internal API errors.
  function invokeAddOrEditMaterial(apiInstance, objectName, materialData) {
    console.log('invokeAddOrEditMaterial', apiInstance, objectName, materialData);
    
    if (!apiInstance || typeof apiInstance.addOrEditMaterial !== "function") {
      return Promise.resolve(null);
    }
    try {
      const result = apiInstance.addOrEditMaterial.call(
        apiInstance,
        objectName,
        materialData
      );
      return result && typeof result.then === "function"
        ? result
        : Promise.resolve(result);
    } catch (error) {
      console.warn(
        "addOrEditMaterial threw synchronously; skipping material update for",
        objectName,
        error
      );
      return Promise.resolve(null);
    }
  }

  function triggerInitialEvents(api) {
    if (!isApiReady || !api) {
      console.warn("Cannot trigger initial events: API not ready or null.");
      return;
    }
    console.log("Attempting to trigger initial events...");

    // Trigger initial preset event (default)
    if (state.activePreset) {
      const eventName = `color-${state.activePreset}-btn`;
      console.log(`Triggering initial preset event: ${eventName}`);
      // Defer apply until API method is confirmed available
      waitForApiMethod(api, "addOrEditMaterial", 100, 100)
        .then(() => applyPreset(api, state.activePreset, true))
        .catch(() => console.warn("Skipping initial preset apply: addOrEditMaterial not available"));
    }
  }

  function setupEventListeners(api) {
    console.log("Setting up event listeners...");
    setupLevelButtons(api);
    setupOverlaminateButtons(api);
    setupLogoButtons(); // Add logo button setup
    setupPresetButtons(api);
    document
      .getElementById("randomizeButton")
      ?.addEventListener("click", () => randomizeColors(api));
    document
      .getElementById("checkout-button")
      ?.addEventListener("click", () => {
        alert("Checkout functionality not implemented in this example.");
      });
    document
      .getElementById("saveConfigButton")
      ?.addEventListener("click", saveConfiguration);
    
    // Add event listener for the download image button
    let downloadInProgress = false;
    document
      .getElementById("download-image")
      ?.addEventListener("click", async (e) => {
        // Prevent multiple rapid clicks
        if (downloadInProgress) {
          console.log("Download already in progress, ignoring click.");
          return;
        }

        if (isApiReady && api && typeof api.dispatchEvent === "function") {
          downloadInProgress = true;
          const button = e.currentTarget;
          const originalHTML = button.innerHTML;
          
          try {
            // Update button UI to show loading state
            button.disabled = true;
            button.innerHTML = `
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 8px; animation: spin 1s linear infinite;">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M12 6v6l4 2"></path>
              </svg>
              <style>@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }</style>
            `;
            button.style.opacity = "0.7";
            button.style.cursor = "wait";
            
            console.log("Download image event dispatched.");
            
            // Use requestIdleCallback or setTimeout to defer the heavy operation
            await new Promise((resolve) => {
              if (typeof requestIdleCallback !== 'undefined') {
                requestIdleCallback(() => {
                  api.dispatchEvent("download-image");
                  resolve();
                }, { timeout: 1000 });
              } else {
                setTimeout(() => {
                  api.dispatchEvent("download-image");
                  resolve();
                }, 50);
              }
            });
            
            // Reset button after a delay
            setTimeout(() => {
              button.disabled = false;
              button.innerHTML = originalHTML;
              button.style.opacity = "";
              button.style.cursor = "";
              downloadInProgress = false;
            }, 1000);
            
          } catch (error) {
            console.error("Error during download image:", error);
            button.disabled = false;
            button.innerHTML = originalHTML;
            button.style.opacity = "";
            button.style.cursor = "";
            downloadInProgress = false;
          }
        } else {
          console.warn("Vectary API not ready or dispatchEvent missing, cannot dispatch download image event.");
        }
      });

    // Add event listener for the selected levels checkout button
    document
      .getElementById("selectedLevelsCheckout")
      ?.addEventListener("click", () => {
        // Get all product IDs for the selected levels
        const productIds = Array.from(window.state.activeLevels)
          .map((level) => window.globalProductData[level])
          .filter((id) => id); // Remove any undefined IDs

        // Get all product IDs for the selected overlaminates
        const overlaminateIds = Array.from(window.state.activeOverlaminates)
          .map((type) => window.overlaminateProductData[type.toLowerCase().replace(" ", "-")])
          .filter((id) => id); // Remove any undefined IDs
        
        // Get logo product IDs to add as separate cart items
        const logoProductIds = Array.from(window.state.activeLogos.values())
          .map((logoData) => ({ id: logoData.productId }))
          .filter((item) => item.id); // Remove any undefined IDs
        
        // Combine level, overlaminate, and logo product arrays
        const allProductIds = [...productIds, ...overlaminateIds, ...logoProductIds];

        if (allProductIds.length > 0) {
          const colorProperties = getColorProperties(); // This now includes logo info as properties
          console.log(
            "Adding selected products to cart from checkout button:",
            { products: allProductIds, properties: colorProperties }
          );
          window.addMultipleProductsToCart(allProductIds, colorProperties);
        } else {
          console.warn('No products selected for checkout');
        }
      });

    console.log("Event listeners setup complete.");
  }

  function disableControls() {
    document
      .querySelectorAll(".controls-panel button, .controls-panel input")
      .forEach((el) => {
        el.disabled = true;
      });
    console.warn("Controls disabled.");
  }

  function randomizeColors(api) {
    let updated = false;
    sliderConfigs.forEach((config) => {
      // Skip Model materials (MC1-MC4) from randomization
      if (config.material.startsWith('Model-MAT-')) {
        console.log(`Skipping randomization for Model material: ${config.material}`);
        return; // Skip this iteration
      }

      const materialId = config.material.replace(/^[^-]+-[^-]+-/, "");
      if (!state.lockedMaterials[materialId]) {
        const sliderElement = document.getElementById(config.sliderId);
        const displayElement = document.getElementById(config.displayId);
        const nameElement = document.getElementById(config.nameId);

        if (sliderElement && displayElement && nameElement) {
          const randomValue = Math.floor(Math.random() * 100) + 1;
          sliderElement.value = randomValue;
          // Update UI via state change (handled by initializeSliderUI listener)
          const updateSliderDisplay = () => {
            const sliderValue = parseInt(sliderElement.value, 10);
            const keyA = `A${sliderValue}`;
            const keyB = `B${sliderValue}`;
            const hexColor = color_swatches_data.hasOwnProperty(keyB)
              ? color_swatches_data[keyB]
              : "#FFFFFF";
            const colorName = color_swatches_data.hasOwnProperty(keyA)
              ? color_swatches_data[keyA]
              : "Unknown";
            displayElement.style.backgroundColor = hexColor;
            nameElement.textContent = colorName;
            state.colorValues[materialId] = sliderValue;
          };
          updateSliderDisplay();
          // Update Vectary material
          updateMaterialColor(
            api,
            sliderElement,
            displayElement,
            nameElement,
            config.objects,
            config.material
          );
          updated = true;
        }
      }
    });

    if (updated) {
      state.activePreset = null;
      updatePresetButtons();
      statusMessage.textContent = "Colors randomized";
      console.log("Randomizing colors...");
      if (isApiReady && api && typeof api.dispatchEvent === "function") {
        api.dispatchEvent("randomize-btn");
        console.log("Event 'randomize-btn' dispatched.");
      } else {
        console.warn(
          "Vectary API not ready or dispatchEvent missing, cannot dispatch randomize event."
        );
      }

      // Update Selected Options Display
      if (typeof window.updateSelectedOptionsDisplay === "function") {
        window.updateSelectedOptionsDisplay(color_swatches_data, state);
      }
    }
  }

  async function applyPreset(api, presetNumber, forceEvent = false) {
    // const presets = { ... }; // Presets object moved to outer DOMContentLoaded scope

    if (presets[presetNumber]) {
      let colorsApplied = false;
      
      // Create a cache of the preset color values before applying them
      // This will be used when changing materials to maintain color consistency
      const presetColorValues = {};
      Object.keys(presets[presetNumber]).forEach(materialId => {
        presetColorValues[materialId] = presets[presetNumber][materialId];
      });
      
      // Store the preset color values in a global cache for use with material changes
      window.cachedPresetColors = presetColorValues;
      
      // Generic handling for model colors (MC1, MC2, Model-Color-1, etc.) which don't have sliders
      console.log('🎨 DEBUG: Processing preset', presetNumber, 'for model colors');
      console.log('🎨 DEBUG: Available materials in preset:', Object.keys(presets[presetNumber]));
      
      for (const materialKey in presets[presetNumber]) {
        // Check if this is a model color material (starts with MC or Model-)
        const isModelColor = materialKey.startsWith('MC') || materialKey.startsWith('Model-');
        console.log(`🎨 DEBUG: Material "${materialKey}" is model color:`, isModelColor);
        
        if (isModelColor) {
          const modelColor = presets[presetNumber][materialKey];
          
          // Extract color and material from the model color data
          let colorValue, materialName;
          
          if (typeof modelColor === 'object' && modelColor.color && modelColor.material) {
            // New format with material information
            colorValue = modelColor.color;
            materialName = modelColor.material;
            console.log(`🎨 DEBUG: Applying model color "${materialKey}": ${colorValue} to material "${materialName}"`);
          } else {
            // Legacy format - just the color value
            colorValue = modelColor;
            materialName = "Model-MAT-C3"; // Fallback for backward compatibility
            console.log(`🎨 DEBUG: Applying model color "${materialKey}":`, colorValue);
          }
          
          // Update state to track the color value
          state.colorValues[materialKey] = typeof colorValue === 'string' ? colorValue : 
                                          (typeof colorValue === 'number' ? colorValue : 38); // Default red if invalid
          
          // Apply the model color directly to the 3D model
          if (isApiReady && api) {
            const modelObjects = ["model-object", "model-detail"];
            const hexColor = typeof colorValue === 'string' && /^#?[0-9a-fA-F]{6}$/.test(colorValue) 
              ? (colorValue.startsWith('#') ? colorValue : `#${colorValue}`) 
              : null;
            
            console.log(`🎨 DEBUG: Hex color for "${materialKey}":`, hexColor);
            
            if (hexColor) {
              // If we have a hex color, apply it directly
              const [r255, g255, b255] = hexToRgb(hexColor);
              const color = { x: r255, y: g255, z: b255 };
              
              console.log(`🎨 DEBUG: RGB color for "${materialKey}":`, color);
              
              for (const objectName of modelObjects) {
                try {
                  console.log(`🎨 DEBUG: Applying to object "${objectName}" with material "${materialName}"`);
                  
                  await api.addOrEditMaterial(objectName, {
                    name: materialName,
                    baseColor: { color },
                  });
                  console.log(`✅ Applied model color ${materialKey} (${hexColor}) to ${objectName}`);
                } catch (e) {
                  console.warn(`❌ Error applying model color ${materialKey} to ${objectName}:`, e);
                }
              }
              colorsApplied = true;
            } else {
              console.warn(`🎨 DEBUG: No valid hex color found for "${materialKey}":`, modelColor);
            }
          } else {
            console.warn('🎨 DEBUG: API not ready or not available');
          }
        }
      }
      
      if (!forceEvent || state.activePreset !== presetNumber) {
        sliderConfigs.forEach((config) => {
          // Extract the material ID by removing the prefix and keeping the material part (C5, C4, etc.)
          const materialId = normalizeMaterialId(config.material);
          
          if (
            !state.lockedMaterials[materialId] &&
            presets[presetNumber][materialId] !== undefined
          ) {
            const sliderElement = document.getElementById(config.sliderId);
            const displayElement = document.getElementById(config.displayId);
            const nameElement = document.getElementById(config.nameId);
            if (sliderElement && displayElement && nameElement) {
               const presetValue = presets[presetNumber][materialId];
               const isHex = typeof presetValue === 'string' && /^#?[0-9a-fA-F]{6}$/.test(presetValue);
               let targetHex = null;
               let targetIndex = null;
               if (isHex) {
                 targetHex = presetValue.startsWith('#') ? presetValue : `#${presetValue}`;
                 targetIndex = findNearestSwatchIndex(targetHex);
               } else {
                 targetIndex = parseInt(presetValue, 10);
               }
               if (parseInt(sliderElement.value) !== targetIndex) {
                 sliderElement.value = targetIndex;
                // Update UI via state change (handled by initializeSliderUI listener)
                const updateSliderDisplay = () => {
                   const sliderValue = parseInt(sliderElement.value, 10);
                   const keyA = `A${sliderValue}`;
                   const keyB = `B${sliderValue}`;
                   const defaultHex = color_swatches_data.hasOwnProperty(keyB)
                     ? color_swatches_data[keyB]
                     : "#FFFFFF";
                   const hexColor = targetHex || defaultHex;
                  const colorName = color_swatches_data.hasOwnProperty(keyA)
                    ? color_swatches_data[keyA]
                    : "Unknown";
                  displayElement.style.backgroundColor = hexColor;
                  nameElement.textContent = colorName;
                  state.colorValues[materialId] = sliderValue;
                };
                updateSliderDisplay();

                
                // Update Vectary material
                updateMaterialColor(
                  api,
                  sliderElement,
                  displayElement,
                  nameElement,
                  config.objects,
                   config.material,
                   targetHex
                );
                colorsApplied = true;
              }
            }
          }
        });
      }

      if (state.activePreset !== presetNumber || colorsApplied || forceEvent) {
        state.activePreset = presetNumber;
        updatePresetButtons();
        if (isApiReady && api && typeof api.dispatchEvent === "function") {
          const eventName = `color-${presetNumber}-btn`;
          api.dispatchEvent(eventName);
        } else {
          console.warn(
            `Vectary API not ready or dispatchEvent missing, cannot dispatch event color-${presetNumber}-btn.`
          );
        }

        // Re-apply active overlaminate selection to keep it persistent across preset changes
        if (
          isApiReady &&
          api &&
          typeof api.setConfigurationState === "function" &&
          state.activeOverlaminates &&
          state.activeOverlaminates.size > 0
        ) {
          try {
            const activeHandle = Array.from(state.activeOverlaminates)[0];
            await api.setConfigurationState([
              { variant: "Variants-Media", active_object: activeHandle },
            ]);
          } catch (e) {
            console.warn("Failed to re-apply overlaminate after preset change", e);
          }
        }

        // Update Selected Options Display
        if (typeof window.updateSelectedOptionsDisplay === "function") {
          window.updateSelectedOptionsDisplay(color_swatches_data, state);
        }
        
        // Save the preset state to localStorage
        saveColorValuesToStorage();
      }
    }
  }

  function setupPresetButtons(api) {
    const presetGrid = document.querySelector(".preset-grid");
    if (!presetGrid) return;
    presetGrid.addEventListener("click", (event) => {
      const btn = event.target.closest('.preset-button');
      if (!btn) return;
      const buttonId = btn.id || '';
      const presetNumber = parseInt(buttonId.split("-")[1]);
      if (!isNaN(presetNumber)) {
        applyPreset(api, presetNumber);
      }
    });
    updatePresetButtons();
  }

  function updatePresetButtons() {
    const buttons = Array.from(document.querySelectorAll(".preset-button"));
    buttons.forEach((button, index) => {
      // Prefer number from id if available, else fall back to order
      const idMatch = (button.id || '').match(/color-(\d+)-btn/);
      const presetNumber = idMatch ? parseInt(idMatch[1], 10) : (index + 1);
      const isActive = state.activePreset === presetNumber;
      button.classList.toggle("active", isActive);
      
      // Get color from preset metafields - look for any model color (MC*, Model-*)
      try {
        const colorsData = button.getAttribute('data-colors');
        if (colorsData) {
          const colors = JSON.parse(colorsData);
          // Find any model color in the preset (MC1, MC2, Model-Color-1, etc.)
          const modelColor = colors.find(c => 
            (c.color_key && (c.color_key.startsWith('MC') || c.color_key.startsWith('Model-'))) ||
            (c.material && (c.material.startsWith('MC') || c.material.startsWith('Model-')))
          );
          
          // Find MC3 for secondary color
          const mc3Color = colors.find(c => c.color_key === 'MC3');
          
          // If we have a model color, apply it to button background AND update the text consistently
          if (modelColor && modelColor.background_color) {
            // Create split background with MC3 as secondary color
            if (mc3Color && mc3Color.background_color) {
              button.style.setProperty('--preset-top-color', `linear-gradient(90deg, ${modelColor.background_color} 50%, ${mc3Color.background_color} 50%)`);
            } else {
              button.style.setProperty('--preset-top-color', modelColor.background_color);
            }
            
            // Update model color names with actual color names using the SAME color from JSON
            const presetMaterial = button.querySelector('.preset-material[data-model-color]');
            if (presetMaterial) {
              // Use the modelColor.background_color from JSON, not the data-model-color attribute
              const fullColorName = getColorNameFromHex(modelColor.background_color);
              // Get first word of primary color
              const colorNameParts = fullColorName.split(' ');
              let displayName = colorNameParts[0]; // Use first word only
              
              // Add MC3 color name if available
              if (mc3Color && mc3Color.background_color) {
                const mc3ColorName = getColorNameFromHex(mc3Color.background_color);
                const mc3FirstWord = mc3ColorName.split(' ')[0]; // Get first word of MC3 color
                displayName = `${displayName} / ${mc3FirstWord}`;
              }
              
              presetMaterial.textContent = displayName;
              // Also update the data attribute to match for consistency
              presetMaterial.setAttribute('data-model-color', modelColor.background_color);
            }
            
            // Also set it for the model color material in presets object if this is the active preset
            if (isActive && presets[presetNumber]) {
              const colorKey = modelColor.color_key || modelColor.material;
              if (colorKey) {
                // Check if the preset already has this model color configured with material info
                const existingModelColor = presets[presetNumber][colorKey];
                if (typeof existingModelColor === 'object' && existingModelColor.material) {
                  // Already has material info, just update the color if needed
                  existingModelColor.color = modelColor.background_color;
                } else {
                  // Create new model color entry with material info if available
                  if (modelColor.material) {
                    presets[presetNumber][colorKey] = {
                      color: modelColor.background_color,
                      material: modelColor.material
                    };
                  } else {
                    // Fallback to simple color value
                    presets[presetNumber][colorKey] = modelColor.background_color;
                  }
                }
                
                // If model color not in the state yet, add it
                if (!state.colorValues[colorKey]) {
                  state.colorValues[colorKey] = modelColor.background_color;
                  state.lockedMaterials[colorKey] = false; // Initialize lock state
                }
              }
            }
          }
        }
      } catch (e) {
        console.warn('Error parsing preset colors for button styling:', e);
      }
      
      let indicator = button.querySelector(".active-indicator");
      if (isActive && !indicator) {
        indicator = document.createElement("span");
        indicator.className = "active-indicator";
        indicator.textContent = "✓"; // Checkmark for active preset
        button.appendChild(indicator);
      } else if (!isActive && indicator) {
        button.removeChild(indicator);
      }

      // Update color dots for each preset button
      const presetColorConfig = presets[presetNumber]; // Loaded from metafields at runtime
      console.log('--------------------------------!!!!!!!!!!!');
      console.log('presetColorConfig', presetColorConfig);
      console.log('--------------------------------!!!!!!!!!!!');
      if (presetColorConfig) {
        const colorDotsContainer = button.querySelector(".preset-colors");
        if (colorDotsContainer) {
            const colorDots = colorDotsContainer.querySelectorAll(".preset-color-dot");
            colorDots.forEach(dot => {
              const colorKey = dot.dataset.colorKey;
              // Exclude model colors from the lower preset bars
              if (colorKey && (colorKey.startsWith('MC') || colorKey.startsWith('Model-'))) {
                dot.style.display = 'none';
                return;
              }
              const val = presetColorConfig[colorKey];
              if (val !== undefined) {
                let colorValue = val;
                if (typeof val === 'object' && val.color) {
                  colorValue = val.color;
                }
                if (typeof colorValue === 'string' && /^#?[0-9a-fA-F]{6}$/.test(colorValue)) {
                  const hex = colorValue.startsWith('#') ? colorValue : `#${colorValue}`;
                  dot.style.backgroundColor = hex;
                } else {
                  const idx = parseInt(val, 10);
                  if (!isNaN(idx)) {
                    const hexColorKey = `B${idx}`;
                    const hexColor = (typeof color_swatches_data !== 'undefined' && color_swatches_data[hexColorKey]) ? color_swatches_data[hexColorKey] : '#FFFFFF';
                    dot.style.backgroundColor = hexColor;
                  } else {
                    dot.style.backgroundColor = '#FFFFFF';
                  }
                }
              } else {
                dot.style.backgroundColor = '#FFFFFF';
              }
            });
        }
      }
    });
  }

  // Model Preset Functions
  async function applyModelPreset(api, presetNumber) {
    console.log(`🎨 Applying model preset ${presetNumber}`);
    
    if (!modelPresets[presetNumber]) {
      console.warn(`Model preset ${presetNumber} not found`);
      return;
    }
    
    const preset = modelPresets[presetNumber];
    
    // Update M1-M4 sliders with preset values
    Object.entries(preset.colors).forEach(([materialId, colorValue]) => {
      const slider = document.getElementById(`swatchSlider${materialId}`);
      const displayElement = document.getElementById(`colorDisplay${materialId}`);
      const nameElement = document.getElementById(`colorName${materialId}`);
      
      if (slider && displayElement && nameElement) {
        // Set slider value
        slider.value = colorValue;
        
        // Update state
        state.colorValues[materialId] = colorValue;
        
        // Update color display
        const keyA = `A${colorValue}`;
        const keyB = `B${colorValue}`;
        const hexColor = color_swatches_data[keyB] || "#FFFFFF";
        const colorName = color_swatches_data[keyA] || "Unknown";
        
        displayElement.style.backgroundColor = hexColor;
        nameElement.textContent = colorName;
        
        // Find the corresponding slider config
        const config = sliderConfigs.find(c => c.sliderId === `swatchSlider${materialId}`);
        if (config) {
          // Update Vectary material
          updateMaterialColor(
            api,
            slider,
            displayElement,
            nameElement,
            config.objects,
            config.material,
            hexColor
          );
        }
      }
    });
    
    // Update active model preset state
    state.activeModelPreset = presetNumber;
    updateModelPresetButtons();
    
    console.log(`✅ Applied model preset ${presetNumber}: ${preset.name}`);
  }

  function updateModelPresetButtons() {
    const buttons = document.querySelectorAll('.model-preset-btn');
    buttons.forEach(button => {
      const presetNumber = parseInt(button.getAttribute('data-preset'));
      button.classList.toggle('active', state.activeModelPreset === presetNumber);
    });
  }

  function setupModelPresetButtons(api) {
    const modelPresetButtons = document.querySelectorAll('.model-preset-btn');
    modelPresetButtons.forEach(button => {
      button.addEventListener('click', () => {
        const presetNumber = parseInt(button.getAttribute('data-preset'));
        applyModelPreset(api, presetNumber);
      });
    });
    
    // Initialize button states
    updateModelPresetButtons();
  }

  function setupLevelButtons(api) {
    const levelGrid = document.querySelector(".level-grid");
    if (!levelGrid) return;
    levelGrid.addEventListener("click", (event) => {
      const button = event.target.closest(".level-button");
      if (button) {
        const levelId = button.id;
        const level = parseInt(levelId.replace("triggerButtonLevel", ""));
        if (!isNaN(level)) {
          triggerLevelEvent(api, level);

          // Toggle active class on the button
          button.classList.toggle("active");

          // Update activeLevels in state
          if (state.activeLevels.has(level)) {
            state.activeLevels.delete(level);
          } else {
            state.activeLevels.add(level);
          }

          // Update selected levels counter
          updateSelectedLevelsCounter();
          // Update price display
          renderConfiguratorTotal();
        }
      }
    });

    // Set initial active states if needed
    updateLevelButtonsActiveState();

    // Initialize selected levels counter
    updateSelectedLevelsCounter();
  // Initial price render after syncing button states
  renderConfiguratorTotal();
  }

  // Function to update the selected levels counter
  function updateSelectedLevelsCounter() {
    const countElement = document.getElementById("selectedLevelsCount");
    const checkoutButton = document.getElementById("selectedLevelsCheckout");

    if (countElement) {
      countElement.textContent = state.activeLevels.size;
    }

    if (checkoutButton) {
      checkoutButton.disabled = state.activeLevels.size === 0;
    }
  }

  function updateLevelButtonsActiveState() {
    // If nothing is selected yet, select all levels by default on load
    try {
      if (state && state.activeLevels && state.activeLevels.size === 0) {
        document.querySelectorAll('.level-button').forEach((button) => {
          const levelId = button.id;
          const level = parseInt(levelId.replace('triggerButtonLevel', ''));
          if (!isNaN(level)) {
            state.activeLevels.add(level);
            button.classList.add('active');
          }
        });
      }
    } catch (_) { /* no-op */ }

    // Update all level buttons to match state.activeLevels
    document.querySelectorAll(".level-button").forEach((button) => {
      const levelId = button.id;
      const level = parseInt(levelId.replace("triggerButtonLevel", ""));
      if (!isNaN(level)) {
        button.classList.toggle("active", state.activeLevels.has(level));
      }
    });

    // Update selected levels counter
    updateSelectedLevelsCounter();
  }

  // Calculate total price in cents for selected levels and overlaminates
  function calculateConfiguratorTotalCents() {
    let total = 0;
    try {
      // Sum selected levels from globalProductData by numeric index
      if (window.globalProductData && state.activeLevels && state.activeLevels.size > 0) {
        Array.from(state.activeLevels).forEach((level) => {
          const item = window.globalProductData[level];
          if (item && typeof item.priceCents === 'number') {
            total += item.priceCents;
          }
        });
      }
      // Sum overlaminate selections by handle key
      if (window.overlaminateProductData && state.activeOverlaminates && state.activeOverlaminates.size > 0) {
        Array.from(state.activeOverlaminates).forEach((handle) => {
          const key = String(handle).toLowerCase().replace(/\s+/g, '-');
          const item = window.overlaminateProductData[key];
          if (item && typeof item.priceCents === 'number') {
            total += item.priceCents;
          }
        });
      }
      // Sum logo selections
      if (state.activeLogos && state.activeLogos.size > 0) {
        Array.from(state.activeLogos.values()).forEach((logoData) => {
          if (logoData.price) {
            // Convert price string to cents (e.g., "25.00" to 2500)
            const priceInCents = Math.round(parseFloat(logoData.price) * 100);
            if (!isNaN(priceInCents)) {
              total += priceInCents;
            }
          }
        });
      }
    } catch (e) {
      console.warn('Failed calculating configurator total:', e);
    }
    return total;
  }

  // Render the total into the main price element using theme's formatter
  function renderConfiguratorTotal() {
    const priceEls = document.querySelectorAll('[data-product-price]');
    if (!priceEls.length || typeof theme === 'undefined' || !theme.Currency || typeof theme.Currency.formatMoney !== 'function') {
      return;
    }
    const totalCents = calculateConfiguratorTotalCents();
    // Fallback to main product price if nothing selected
    const baseCents = (window.mainProduct && typeof window.mainProduct.priceCents === 'number') ? window.mainProduct.priceCents : 0;
    const displayCents = totalCents > 0 ? totalCents : baseCents;
    try {
      const formattedPrice = theme.Currency.formatMoney(displayCents, theme.settings && theme.settings.moneyFormat ? theme.settings.moneyFormat : undefined);
      priceEls.forEach(el => el.innerHTML = formattedPrice);
    } catch (e) {
      console.warn('Failed formatting configurator total:', e);
    }
  }

  function triggerLevelEvent(api, level) {
    if (isApiReady && api && typeof api.dispatchEvent === "function") {
      const eventName = `level-${level}-btn`;
      api.dispatchEvent(eventName);

      // Toggle the visibility of the level item in the selected options display
      const levelItem = document.querySelector(
        `.level-item[data-level="${level}"]`
      );
      if (levelItem) {
        // Check current visibility and toggle it
        const isVisible = levelItem.style.display !== "none";
        levelItem.style.display = isVisible ? "none" : "flex";
      }
    } else {
      console.warn(
        `Vectary API not ready or dispatchEvent missing, cannot dispatch event level-${level}-btn.`
      );
      statusMessage.textContent = `Error: API not ready.`;
    }
  }

  function setupOverlaminateButtons(api) {
    const overlaminateGrid = document.querySelector(".overlaminate-grid");
    if (!overlaminateGrid) return;
    
    overlaminateGrid.addEventListener("click", async (event) => {
      const button = event.target.closest(".overlaminate-button");
      if (button) {
        const overlaminateHandle = button.getAttribute("data-overlaminate-handle");
        if (overlaminateHandle) {
          const isCurrentlyActive = state.activeOverlaminates.has(overlaminateHandle);
          
          // Only add the new selection if it wasn't already active
          if (!isCurrentlyActive) {
            // Determine which color values to use based on active preset or current state
            let colorValuesToUse;
            
            // If a preset is active, use the cached preset colors
            if (state.activePreset && window.cachedPresetColors) {
              colorValuesToUse = window.cachedPresetColors;
              console.log('Using cached preset colors for material change:', colorValuesToUse);
            } else {
              // Otherwise use the current color values
              colorValuesToUse = JSON.parse(JSON.stringify(state.colorValues));
              console.log('Using current color values for material change:', colorValuesToUse);
            }
            
            // Clear UI state first
            document.querySelectorAll(".overlaminate-button").forEach(btn => {
              btn.classList.remove("active");
            });
            
            // Clear all active overlaminates
            state.activeOverlaminates.clear();
            
            // Add active class to the clicked button
            button.classList.add("active");
            
            // Add to activeOverlaminates in state
            state.activeOverlaminates.add(overlaminateHandle);
            // Update price display after overlaminate change
            renderConfiguratorTotal();
            
            // Apply overlaminate by configuration only (no extra dispatch) to avoid API re-init races
            if (isApiReady && api) {
              // Get the new material type from the button
              const overlaminateMaterial = button.getAttribute("data-material");
              console.log('Overlaminate button clicked:', {
                button: button.id,
                dataMaterial: overlaminateMaterial,
                dataOverlaminateHandle: button.getAttribute("data-overlaminate-handle")
              });

              // Store the new selected material - use default if empty
              selectedOverlaminateMaterial = overlaminateMaterial || 'MAT-MATTE';
              console.log('!!!!!Set selectedOverlaminateMaterial to:', selectedOverlaminateMaterial);

              // Update the configuration state in Vectary
              try {
                await api.setConfigurationState([
                  {
                    variant: "Variants-Media",
                    active_object: overlaminateHandle
                  }
                ]);
              } catch (e) {
                console.warn("Failed to update Vectary configuration for overlaminate:", e);
              }

              // Wait for Vectary API to stabilize after configuration change
              try {
                await waitForApiMethod(api, "addOrEditMaterial", 50, 100);
              } catch (e) {
                console.warn("API method not available after overlaminate change:", e);
              }

              // Re-apply current colors to restabilize the API (same approach as presets)
              try {
                sliderConfigs.forEach((config) => {
                  const sliderElement = document.getElementById(config.sliderId);
                  const displayElement = document.getElementById(config.displayId);
                  const nameElement = document.getElementById(config.nameId);
                  if (sliderElement && displayElement && nameElement) {
                    updateMaterialColor(
                      api,
                      sliderElement,
                      displayElement,
                      nameElement,
                      config.objects,
                      config.material
                    );
                  }
                });
              } catch (e) {
                console.warn("Failed to re-apply colors after overlaminate change:", e);
              }

              // Update the display with fresh data
              if (typeof window.updateSelectedOptionsDisplay === "function") {
                window.updateSelectedOptionsDisplay(color_swatches_data, state);
              }

              // Save the overlaminate state to localStorage
              saveColorValuesToStorage();
            } else {
              console.warn(`Vectary API not ready, cannot update overlaminate configuration.`);
            }
          }
        }
      }
    });

    // Set initial active states
    updateOverlaminateButtonsActiveState();
  }

  // Function to update the overlaminate buttons active state
  function updateOverlaminateButtonsActiveState() {
    // Update all overlaminate buttons to match state.activeOverlaminates
    if (!isApiReady) return;
    const firstBtn = document.querySelector(".overlaminate-button");
    if (firstBtn && typeof firstBtn.click === 'function') {
      firstBtn.click();
    }
  }

  // Logo button setup and handling
  function setupLogoButtons() {
    const logoButtons = document.querySelectorAll('.logo-button');
    
    logoButtons.forEach((button) => {
      button.addEventListener('click', function() {
        const logoItem = this.closest('.logo-item');
        const logoId = logoItem.getAttribute('data-logo-id');
        const logoHandle = this.getAttribute('data-logo-handle');
        const logoTitle = this.getAttribute('data-logo-title');
        const logoProductId = this.getAttribute('data-logo-product-id');
        const logoPrice = this.getAttribute('data-logo-price');
        const inputGroup = logoItem.querySelector('.logo-input-group');
        const textInput = logoItem.querySelector('.logo-text-input');
        
        // Toggle active state
        const isActive = this.classList.contains('active');
        
        if (isActive) {
          // Deactivate
          this.classList.remove('active');
          inputGroup.style.display = 'none';
          textInput.value = '';
          
          // Remove from active logos
          state.activeLogos.delete(logoId);
        } else {
          // Activate
          this.classList.add('active');
          inputGroup.style.display = 'block';
          
          // Focus on input after a brief delay for animation
          setTimeout(() => textInput.focus(), 100);
          
          // Add to active logos with product info
          state.activeLogos.set(logoId, {
            handle: logoHandle,
            title: logoTitle,
            productId: logoProductId,
            price: logoPrice,
            text: textInput.value || ''
          });
        }
        
        // Update price display
        renderConfiguratorTotal();
      });
      
      // Update logo text when input changes
      const logoItem = button.closest('.logo-item');
      const textInput = logoItem.querySelector('.logo-text-input');
      const logoId = logoItem.getAttribute('data-logo-id');
      
      textInput.addEventListener('input', function() {
        if (state.activeLogos.has(logoId)) {
          const logoData = state.activeLogos.get(logoId);
          logoData.text = this.value;
        }
      });
    });
  }

  function saveConfiguration() {
  // Normalize keys before exporting
  normalizeStateColorValues();
  
  // Export colorValues with hex codes and names
  const exportColorValues = {};
  Object.keys(state.colorValues).forEach(key => {
    const index = state.colorValues[key];
    const hex = color_swatches_data[`B${index}`] || '#ffffff';
    const name = color_swatches_data[`A${index}`] || 'Unknown';
    exportColorValues[key] = { hex, name };
  });
  
  const configData = {
      activePreset: state.activePreset,
      colorValues: exportColorValues,
      lockedMaterials: state.lockedMaterials,
      activeLevels: Array.from(state.activeLevels), // Convert Set to Array for JSON serialization
      activeOverlaminates: Array.from(state.activeOverlaminates), // Add overlaminates to saved config
    };
    const configBlob = new Blob([JSON.stringify(configData, null, 2)], {
      type: "application/json",
    });
    const url = URL.createObjectURL(configBlob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "ski-doo-configuration.json";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    statusMessage.textContent = "Configuration saved successfully";
  }

  // --- Initial UI Setup Calls ---
  updatePresetButtons();
  initializeSliderUI(); // Setup slider UI without API calls
  // Repaint preset dots shortly after DOM hydration (handles metafields rendered after first paint)
  setTimeout(updatePresetButtons, 50);

  // --- Initialize Vectary API ---
  (async () => {
    try {
      console.log("Attempting to initialize Vectary API...");
      const apiInstance = new VctrModelApi("VECTARY_EMBED_ID");
      await apiInstance.init();
      modelApi = apiInstance; // Assign to outer scope variable
      console.log("Vectary API initialized successfully (via init).");

      // Polling check for dispatchEvent method
      await waitForApiMethod(modelApi, "dispatchEvent", 50, 100);

      isApiReady = true; // Set ready flag
      
      // Apply saved overlaminate material if available
      const savedOverlaminateMaterial = localStorage.getItem('vectaryOverlaminateMaterial');
      if (savedOverlaminateMaterial) {
        selectedOverlaminateMaterial = savedOverlaminateMaterial;
        
        // Find and click the corresponding overlaminate button
        const overlaminateButton = document.querySelector(`.overlaminate-button[data-material="${savedOverlaminateMaterial}"]`);
        if (overlaminateButton) {
          console.log('Applying saved overlaminate material:', savedOverlaminateMaterial);
          // Just update the UI, don't trigger the click event to avoid double processing
          overlaminateButton.classList.add('active');
          
          // Update active overlaminates in state
          const overlaminateHandle = overlaminateButton.getAttribute("data-overlaminate-handle");
          if (overlaminateHandle) {
            state.activeOverlaminates.clear();
            state.activeOverlaminates.add(overlaminateHandle);
          }
        }
      }

      // Re-Initialize Sliders with API connection
      initializeSlidersWithAPI(modelApi); // Changed name for clarity
      
      // Apply saved preset if available
      const savedActivePreset = localStorage.getItem('vectaryActivePreset');
      if (savedActivePreset) {
        const presetNumber = parseInt(savedActivePreset, 10);
        console.log('Applying saved preset:', presetNumber);
        applyPreset(modelApi, presetNumber, true);
      } else {
        // If no preset is saved, apply the saved color values directly
        const savedColorValues = localStorage.getItem('vectaryColorValues');
        if (savedColorValues) {
          const colorValues = JSON.parse(savedColorValues);
          console.log('Applying saved color values:', colorValues);
          
          // Apply each saved color value
          for (const colorKey in colorValues) {
            const colorValue = colorValues[colorKey];
            const sliderConfig = sliderConfigs.find(config => 
              config.material.endsWith(colorKey));
            
            if (sliderConfig) {
              const slider = document.getElementById(sliderConfig.sliderId);
              const display = document.getElementById(sliderConfig.displayId);
              const nameElement = document.getElementById(sliderConfig.nameId);
              
              if (slider && display && nameElement) {
                slider.value = colorValue;
                updateMaterialColor(
                  modelApi,
                  slider,
                  display,
                  nameElement,
                  sliderConfig.objects,
                  sliderConfig.material
                );
              }
            }
          }
          
          // Update the selected options display with the loaded values
          if (typeof window.updateSelectedOptionsDisplay === "function") {
            window.updateSelectedOptionsDisplay(color_swatches_data, state);
          }
        }
      }

      // Setup Event Listeners
      setupEventListeners(modelApi);
      window.modelApi = modelApi;

      // Initialize Selected Options Display
      if (typeof window.initSelectedOptionsDisplay === "function") {
        window.initSelectedOptionsDisplay(products, color_swatches_data, state);
      }

  // Initial render of configurator total after init
  renderConfiguratorTotal();

      // Add listeners for color changes to update selected options display
      sliderConfigs.forEach((config) => {
        const sliderElement = document.getElementById(config.sliderId);
        if (sliderElement) {
          sliderElement.addEventListener("input", function () {
            if (typeof window.updateSelectedOptionsDisplay === "function") {
              window.updateSelectedOptionsDisplay(color_swatches_data, state);
            }
          });
        }
      });

      // Listen for selected-options events
      document.addEventListener(
        "selected-options-remove-level",
        function (event) {
          const level = event.detail.level;
          if (level && typeof triggerLevelEvent === "function") {
            triggerLevelEvent(modelApi, level);
          }
        }
      );

      // Listen for selected-options events
      document.addEventListener("selected-options-checkout", function (event) {
        // Retrieve color properties from the event if available
        const colorProperties =
          event.detail && event.detail.colorProperties
            ? event.detail.colorProperties
            : {};

        console.log(
          "Proceeding to checkout with color properties:",
          colorProperties
        );

        // Get all selected level products from state.activeLevels
        if (state.activeLevels.size > 0) {
          // Get all product IDs for the selected levels
          const productIds = Array.from(state.activeLevels)
            .map((level) => window.globalProductData[level])
            .filter((id) => id); // Remove any undefined IDs

          if (productIds.length > 0) {
            console.log("Adding selected level products to cart:", productIds);
            window.addMultipleProductsToCart(productIds, colorProperties);
            return; // Skip the rest of the function since we're handling it in addMultipleProductsToCart
          }
        }

        // Fallback to original behavior if no levels are selected
        // Check if we have variant information and add to cart
        // Look for variant info in the page, common in Shopify product pages
        const variantIdInput = document.querySelector(
          'input[name="id"], select[name="id"]'
        );
        if (variantIdInput && variantIdInput.value) {
          const variantId = variantIdInput.value;
          // Add to cart with properties and proceed to checkout
          window.addToCartWithColorProperties(variantId, 1, colorProperties);
        } else {
          // Just save the color properties as cart attributes and proceed to checkout
          fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ attributes: colorProperties }),
          })
            .then((response) => response.json())
            .then((cart) => {
              console.log(
                "Cart updated with color properties as attributes:",
                cart
              );
              window.location.href = "/checkout";
            })
            .catch((error) => {
              console.error("Error updating cart:", error);
              alert("There was an error updating the cart. Please try again.");
            });
        }
      });

      // Trigger initial events
      triggerInitialEvents(modelApi);
    } catch (error) {
      console.error("Error initializing or verifying Vectary API:", error);
      if (error instanceof Error) {
        console.error("Error name:", error.name);
        console.error("Error message:", error.message);
        console.error("Error stack:", error.stack);
      } else {
        console.error("Caught non-Error object:", error);
      }
      statusMessage.textContent = "Error initializing 3D model. Check console.";
      disableControls();
    }
  })(); // End of async IIFE for initialization
}); // End of DOMContentLoaded listener

const levelButtons = document.querySelectorAll(".level-button");
const coverageButtons = document.querySelectorAll(
  '[data-handle="coverage"] [data-variant-input]'
);
const presetButtons = document.querySelectorAll(".preset-button");
const variantButtons = document.querySelectorAll(
  '[data-handle="color"] [data-variant-input]'
);

document.addEventListener("DOMContentLoaded", () => {
  // Guard to avoid reacting to programmatic initializations
  window.__initializingLevels = true;
  presetButtons.forEach((button, index) => {
    button.addEventListener("click", () => {
      if (variantButtons[index]) variantButtons[index].click();
    });
  });

  variantButtons.forEach((button, index) => {
    button.addEventListener("click", () => {
      if (presetButtons[index]) presetButtons[index].click();
    });
  });

  // Updated event handling for level buttons - don't just click coverage buttons
  // Instead, toggle the active state and update state.activeLevels
  levelButtons.forEach((button, index) => {
    button.addEventListener("click", () => {
      // Don't automatically click coverageButtons to allow independent selection
      // Just make sure the UI reflects the state correctly
      // This is handled in setupLevelButtons now
    });
  });

  // Update coverage buttons to work with multi-selection
  coverageButtons.forEach((button, index) => {
    button.addEventListener("click", () => {
      if (window.__initializingLevels) return; // ignore during boot
      const levelButton = levelButtons[index];
      if (levelButton) {
        levelButton.classList.toggle("active", button.checked);

        // Update state.activeLevels
        const level = parseInt(
          levelButton.id.replace("triggerButtonLevel", "")
        );
        if (!isNaN(level)) {
          if (button.checked) {
            window.state.activeLevels.add(level);
          } else {
            window.state.activeLevels.delete(level);
          }
        }
      }
    });
  });

  // Set initial button states
  variantButtons.forEach((button, index) => {
    if (button.checked) {
      presetButtons[index].click();
    }
  });

  // Set initial level button states based on coverage buttons
  coverageButtons.forEach((button, index) => {
    // if (button.checked) {
      const levelButton = levelButtons[index];
      if (levelButton) {
        levelButton.classList.add("active");
        const level = parseInt(
          levelButton.id.replace("triggerButtonLevel", "")
        );
        if (!isNaN(level)) {
          window.state.activeLevels.add(level);
        }
      }
    // }
  });
  // End of initialization; enable user-driven coverage toggles
  window.__initializingLevels = false;
});
document.addEventListener("DOMContentLoaded", function () {   
  // Access state from vectary embed context
  // This relies on the state variable being accessible in the page scope

  // Find all Add to Cart forms on the page and add submission handler
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

  addToCartForms.forEach((form) => {
    form.addEventListener("submit", function (event) {
      // Prevent default form submission
      event.preventDefault();

      // Get color properties
      const colorProperties = getColorProperties();

      // Check if we have active levels or overlaminates to add to cart
      if (
        window.state &&
        (window.state.activeLevels.size > 0 || window.state.activeOverlaminates.size > 0)
      ) {
        // Get product IDs for all selected levels
        const productIds = Array.from(window.state.activeLevels)
          .map((level) => window.globalProductData[level])
          .filter((id) => id); // Remove any undefined IDs

        // Get product IDs for all selected overlaminates
        const overlaminateIds = Array.from(window.state.activeOverlaminates)
          .map((type) => window.overlaminateProductData[type.toLowerCase().replace(" ", "-")])
          .filter((id) => id); // Remove any undefined IDs

        // Combine both arrays
        const allProductIds = [...productIds, ...overlaminateIds];
        if (allProductIds.length > 0) {
          console.log(
            "Adding selected products to cart from form submit:",
            allProductIds
          );
          window.addMultipleProductsToCart(allProductIds, colorProperties);
          return;
        }
      }

      // If no levels are selected, continue with original behavior
      if (Object.keys(colorProperties).length > 0) {
        // Remove any existing color property inputs
        const existingPropertyInputs = form.querySelectorAll(
          'input[name^="properties[Color_"]'
        );
        existingPropertyInputs.forEach((input) => input.remove());

        // Add property inputs to the form
        Object.keys(colorProperties).forEach((key) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = `properties[${key}]`;
          input.value = colorProperties[key];
          form.appendChild(input);
        });

        console.log("Adding to cart with color properties:", colorProperties);
      }

      // Submit the form
      form.submit();
    });
  });

  // Function to collect all properties from product-single__form
  function collectFormProperties(form) {
    const properties = {};

    if (!form) return properties;

    // Get all input fields with name starting with "properties["
    const propertyInputs = form.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]');

    propertyInputs.forEach(input => {
      const name = input.name;
      const value = input.value;

      if (name && value) {
        // Extract property name from properties[PropertyName]
        const propertyName = name.match(/properties\[(.*?)\]/);
        if (propertyName && propertyName[1]) {
          properties[propertyName[1]] = value;
        }
      }
    });

    // Also collect from any custom options wrapper if it exists
    const customOptionsWrapper = document.querySelector('[data-custom-options-wrapper]');
    if (customOptionsWrapper) {
      const customFields = customOptionsWrapper.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]');

      customFields.forEach(field => {
        const name = field.name;
        const value = field.value;

        if (name && value) {
          const propertyName = name.match(/properties\[(.*?)\]/);
          if (propertyName && propertyName[1]) {
            properties[propertyName[1]] = value;
          }
        }
      });
    }

    return properties;
  }

  // Handle direct "Add to Cart" button clicks that might use AJAX
  const addToCartButtons = document.querySelectorAll("[data-add-to-cart]");
  addToCartButtons.forEach((button) => {
    button.style.pointerEvents = "all";
    // Store original click handler by cloning the node
    const newButton = button.cloneNode(true);

    // Replace with our intercepted version
    button.parentNode.replaceChild(newButton, button);
    newButton.removeAttribute("disabled");

    // Add our click handler
    newButton.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      const parentForm = this.closest("form");
      // Check if we have active levels or overlaminates to add to cart
      if (
        parentForm &&
        window.state &&
        (window.state.activeLevels.size > 0 || window.state.activeOverlaminates.size > 0)
      ) {
        // This is for direct button clicks without forms

        // Get color properties
        const colorProperties = getColorProperties();

        // Get all properties from the form
        const formProperties = collectFormProperties(parentForm);

        // Combine color properties with form properties
        const allProperties = { ...colorProperties, ...formProperties };

        // Get product IDs for all selected levels
        const productIds = Array.from(window.state.activeLevels)
          .map((level) => window.globalProductData[level])
          .filter((id) => id); // Remove any undefined IDs

        // Get product IDs for all selected overlaminates
        const overlaminateIds = Array.from(window.state.activeOverlaminates)
          .map((type) => window.overlaminateProductData[type.toLowerCase().replace(" ", "-")])
          .filter((id) => id); // Remove any undefined IDs

        // Get logo product IDs to add as separate cart items
        const logoProductIds = Array.from(window.state.activeLogos.values())
          .map((logoData) => ({ id: logoData.productId }))
          .filter((item) => item.id); // Remove any undefined IDs

        // Combine both arrays
        const allProductIds = [...productIds, ...overlaminateIds, ...logoProductIds];

        if (allProductIds.length > 0) {
          console.log(
            "Adding selected products to cart from button click:",
            allProductIds,
            "with properties:",
            allProperties
          );
          window.addMultipleProductsToCart(allProductIds, allProperties);
          return;
        }
      }

      // If the button is not inside a form, it likely uses AJAX
      if (!parentForm) {
        // This is for AJAX add to cart
        const colorProperties = getColorProperties();

        // Try to find the product form to get all properties
        const productForm = document.querySelector('.product-single__form');
        const formProperties = collectFormProperties(productForm);

        // Combine color properties with form properties
        const allProperties = { ...colorProperties, ...formProperties };

        // Store the properties in sessionStorage to be used by AJAX handlers
        if (Object.keys(allProperties).length > 0) {
          sessionStorage.setItem(
            "vectaryColorProperties",
            JSON.stringify(allProperties)
          );
          console.log(
            "Stored all properties for AJAX add to cart:",
            allProperties
          );
        }
      }
      // Form submission is handled by the form submit event handler
    });
  });

  // Intercept AJAX cart additions by monkeypatching fetch and XMLHttpRequest
  const originalFetch = window.fetch;
  window.fetch = function () {
    const url = arguments[0];

    // Check if this is an add to cart request
    if (url && (url.includes("/cart/add") || url === "/cart/add.js")) {
      try {
        const colorProperties = JSON.parse(
          sessionStorage.getItem("vectaryColorProperties") || "{}"
        );

        if (Object.keys(colorProperties).length > 0) {
          // Clone the request
          const newArgs = [...arguments];

          if (newArgs[1] && newArgs[1].body) {
            let body;

            // Handle FormData
            if (newArgs[1].body instanceof FormData) {
              body = newArgs[1].body;
              // Add properties to FormData
              Object.keys(colorProperties).forEach((key) => {
                body.append(`properties[${key}]`, colorProperties[key]);
              });
              newArgs[1].body = body;
            }
            // Handle JSON
            else if (typeof newArgs[1].body === "string") {
              try {
                body = JSON.parse(newArgs[1].body);
                if (!body.properties) body.properties = {};

                // Add color properties
                Object.keys(colorProperties).forEach((key) => {
                  body.properties[key] = colorProperties[key];
                });

                newArgs[1].body = JSON.stringify(body);
              } catch (e) {
                console.error("Error parsing fetch body:", e);
              }
            }
          }

          console.log(
            "Intercepted AJAX cart add with color properties:",
            colorProperties
          );
          // Clear stored properties after use
          sessionStorage.removeItem("vectaryColorProperties");

          return originalFetch.apply(this, newArgs);
        }
      } catch (e) {
        console.error("Error intercepting fetch:", e);
      }
    }

    return originalFetch.apply(this, arguments);
  };
});



// Accordion behavior for color sliders
document.querySelectorAll('.accordion-header').forEach(header => {
  header.addEventListener('click', function() {
    const expanded = this.getAttribute('aria-expanded') === 'true';
    const panel = document.getElementById(this.getAttribute('aria-controls'));

    // Collapse all other accordions
    document.querySelectorAll('.accordion-header').forEach(h => {
      if (h !== this) {
        h.setAttribute('aria-expanded', 'false');
        const p = document.getElementById(h.getAttribute('aria-controls'));
        p.classList.add('accordion-collapsed');
      }
    });

    // Toggle the current accordion
    if (expanded) {
      this.setAttribute('aria-expanded', 'false');
      panel.classList.add('accordion-collapsed');
    } else {
      this.setAttribute('aria-expanded', 'true');
      panel.classList.remove('accordion-collapsed');
    }
  });
});

// Optionally, expand the first panel by default
const firstHeader = document.querySelector('.accordion-header');
if (firstHeader) {
    firstHeader.setAttribute('aria-expanded', 'true');
    const firstPanel = document.getElementById(firstHeader.getAttribute('aria-controls'));
    firstPanel.classList.remove('accordion-collapsed');
}

document.getElementById("expandAllSliders")?.addEventListener("click", function() {
  document.querySelectorAll('.accordion-header').forEach(header => {
    header.setAttribute('aria-expanded', 'true');
  });
  document.querySelectorAll('.accordion-panel').forEach(panel => {
    panel.classList.remove('accordion-collapsed');
  });
});

// Initialize Color Grid Popup when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM loaded, checking for ColorGridPopup...');
  if (typeof window.ColorGridPopup !== 'undefined') {
    console.log('ColorGridPopup available, initializing...');
    window.ColorGridPopup.init().catch(error => {
      console.error('Failed to initialize ColorGridPopup on DOM ready:', error);
    });
  } else {
    console.log('ColorGridPopup not yet available on DOM ready, will initialize on first use');
  }
});

// --- 3D Player Dropdowns Add to Cart Logic ---
document.addEventListener('DOMContentLoaded', function() {
  function getSelectedOptions() {
    return {
      gen5_engine: document.getElementById('gen5-engine')?.value,
      gen5_package: document.getElementById('gen5-package')?.value,
      gen5_model_year: document.getElementById('gen5-model-year')?.value
    };
  }

  function addToCartWithAttributes() {
    var options = getSelectedOptions();
    var variantId = window.mainProduct?.id || window.productVariantId;
    if (!variantId) {
      alert('No product variant selected.');
      return;
    }
    var formData = {
      items: [{
        id: variantId,
        quantity: 1,
        properties: {
          "Gen5 Engine": options.gen5_engine || '',
          "Gen5 Package": options.gen5_package || '',
          "Gen5 Model Year": options.gen5_model_year || ''
        }
      }]
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      window.location.href = '/checkout';
    });
  }

  // Remove event listener for duplicate button. Instead, hook into main cart form submission
  var mainCartForm = document.querySelector('form[action="/cart/add"]');
  if (mainCartForm) {
    mainCartForm.addEventListener('submit', function(e) {
      var options = getSelectedOptions();
      // Always set line item properties for dropdown selections
      ['Gen5 Engine','Gen5 Package','Gen5 Model Year'].forEach(function(prop) {
        var input = mainCartForm.querySelector('input[name="properties[' + prop + ']"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[' + prop + ']';
          mainCartForm.appendChild(input);
        }
        input.value = options['gen5_' + prop.replace(' ', '_').toLowerCase()] || '';
      });
    });
  }
});